import type {ReactNode} from 'react';
import {useRef} from 'react';
import {PostHogProvider} from 'posthog-js/react';
import posthog from 'posthog-js';
import {
  initAnalytics,
  type AnalyticsCapture,
  type AnalyticsProperties,
} from '@common-web/lib/analytics';

export type AnalyticsProviderProps = {
  app: string;
  /** Extra fields registered on every event (static per app). `app` and `env` are added automatically. */
  superProperties?: AnalyticsProperties;
  /** Overrides of AnalyticsCapture defaults. Omit a field to keep the shared default. */
  capture?: AnalyticsCapture;
  children: ReactNode;
};

export function AnalyticsProvider({
  app,
  superProperties,
  capture,
  children,
}: AnalyticsProviderProps) {
  const loadedRef = useRef<boolean | null>(null);
  if (loadedRef.current === null) {
    loadedRef.current = initAnalytics({app, capture, superProperties});
  }

  if (!loadedRef.current) return children;
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
